export class EmptyInputValue {
    constructor(optionalOptions = {}) {
        this._inputsEmptyButtons = document.querySelectorAll('.base-input-wrp-search--empty');

        if (!this._inputsEmptyButtons) {
            this.destructor();
            return true;
        }

        this._inputsEmptyButtons.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()
                button.parentNode.querySelector('input').value = "";
                return false
            })
        })
    }

    destructor() {
        this._inputsEmptyButtons = null;
    }
}

export default new EmptyInputValue();